import React, { FC, PropsWithChildren } from "react";
import { MsalAuthenticationTemplate, MsalProvider } from "@azure/msal-react";
import { InteractionType } from "@azure/msal-browser";
import { msalInstance } from "auth/authConfig";
import { css, Global, ThemeProvider } from "@emotion/react";
import { BrowserRouter } from "react-router";
import { Provider } from "react-redux";
import { store } from "stores/application.store";
import { themeMap } from "styles/themes/baseTheme";
import SidebarProvider from "context/SidebarProvider";
import Impersonation from "components/Impersonation/Impersonation";
import ConfigurationProvider from "context/configurations/ConfigurationProvider";
import ScrollToTop from "components/Common/ScrollToTop/ScrollToTop";
import ErrorBoundary from "components/ErrorBoundary/ErrorBoundary";

const globalStyles = css({
	":root": {
		fontVariantNumeric: "tabular-nums",
		// Fallback for broader OpenType support
		fontFeatureSettings: '"tnum" 1',
		fontVariantLigatures: "none"
	}
});

const AuthProvider: FC<PropsWithChildren> = ({ children }) => {
	return (
		<MsalProvider instance={msalInstance}>
			<MsalAuthenticationTemplate interactionType={InteractionType.Redirect}>
				{children}
			</MsalAuthenticationTemplate>
		</MsalProvider>
	);
};

// wraps app with all necessary providers
export const AppProviders: FC<PropsWithChildren> = ({ children }) => {
	return (
		<ErrorBoundary>
			<Provider store={store}>
				<AuthProvider>
					<SidebarProvider>
						<ThemeProvider theme={themeMap.defaultTheme}>
							<Global styles={globalStyles} />
							<BrowserRouter>
								<ScrollToTop>
									<ConfigurationProvider>
										<Impersonation>{children}</Impersonation>
									</ConfigurationProvider>
								</ScrollToTop>
							</BrowserRouter>
						</ThemeProvider>
					</SidebarProvider>
				</AuthProvider>
			</Provider>
		</ErrorBoundary>
	);
};
